import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import { useSelector, useDispatch } from "react-redux";
import { fetchAdvisorData } from "../../../redux/advisor/advisorSlice";
import { GiRotaryPhone } from "react-icons/gi";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { IoLogoLinkedin } from "react-icons/io5";
import api from "../../../utils/api";

const Home = ({ isConnected }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const roomId = queryParams.get("clientId");
  const refToken = decodeURIComponent(queryParams.get("refToken"));
  const [firstToken, setIsFirstToken] = useState(false);

  const {
    advisorData,
    loading: advisorLoading,
    error: advisorError,
  } = useSelector((state) => state.advisor);

  console.log("AdvisorData", advisorData);

  const completeLinkedinUrl = advisorData?.linkedin_url?.startsWith("http")
    ? advisorData.linkedin_url
    : `https://${advisorData?.linkedin_url}`;

  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);

  const isLoading = advisorLoading || clientLoading;

  // useEffect(() => {
  //   if (refToken && refToken !== "null") {
  //     localStorage.setItem("authToken", refToken);

  //     queryParams.delete("refToken");
  //     window.history.replaceState(
  //       {},
  //       document.title,
  //       `${window.location.pathname}?${queryParams.toString()}`
  //     );
  //     setIsFirstToken(true);
  //   }else{
  //  window.location.href = `https://crm-dia.netlify.app/sign-in`;

  //   }
  // }, []);

  useEffect(() => {
    if (localStorage.getItem("refToken")) {
      firstToken(true);
    }
  }, []);

  // Fetch client data using Redux
  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, [dispatch]);

  // Fetch advisor data using Redux
  // useEffect(() => {
  //   const token = localStorage.getItem("authToken");
  //   if (token) {
  //     const decoded = jwtDecode(token);
  //     console.log('decoded',decoded);

  //     dispatch(fetchAdvisorData(decoded.id));

  //   } else {

  //     console?.error("Token not found");
  //   }
  // }, [dispatch]);

  useEffect(() => {
    if (clientData?.advisor_id) {
      dispatch(fetchAdvisorData(clientData?.advisor_id));
    }
  }, [clientData]);

  useEffect(() => {
    if (!isConnected) return;
    socket.emit("join", roomId);
    socket.on("navigate", (data) => {
      const url = new URL(window.location.origin + data);

      // 👇 Inject clientId if it's missing
      if (!url.searchParams.get("clientId") && roomId) {
        url.searchParams.set("clientId", roomId);
      }

      navigate(url.pathname + url.search);
    });
    if (firstToken) {
      const nextUrl = `/?clientId=${roomId}&refToken=${encodeURIComponent(
        localStorage.getItem("authToken"),
      )}`;
      socket.emit("navigate", { room: roomId, url: nextUrl });
    }

    return () => socket.off("navigate");
  }, [isConnected, navigate, firstToken]);

  const handleNext = () => {
    const nextUrl = `/dream?clientId=${roomId}`;
    const nextUrl2 = `/dream`;
    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
  };

  const fullName = `${clientData?.firstName || ""} ${
    clientData?.middleName || ""
  } ${clientData?.lastName || ""}`.trim();
  const formatAUM = (value) => {
    if (value >= 10000000) {
      return (value / 10000000).toFixed(0) + " Crores";
    } else if (value >= 100000) {
      return (value / 100000).toFixed(0) + " Lakhs";
    } else if (value >= 1000) {
      return (value / 1000).toFixed(0) + " Thousand";
    } else if (value >= 100) {
      return (value / 100).toFixed(0) + " Hundred";
    } else {
      return value;
    }
  };

  console.log("advisorData", advisorData);

  /////////////////
  // for house hold data run this api
  useEffect(() => {
    if (clientData?._id) {
      investmentLivePortfolioWm();
    }
  }, [clientData]);

  const investmentLivePortfolioWm = () => {
    try {
      const res = api.post("advisor/investmentLivePortfolioWm", {
        clientid: roomId,
        groupId: "",
      });
      console.log("apiInvestmentLivePortfolioWm", res);
    } catch (error) {
      console.error("Error fetching investment live portfolio:", error);
    }
  };
  /////////////////
  // const stripHtmlTags = (html = '') =>
  // html?.replace(/<\/?p[^>]*>/g, '')

  const stripHtmlTags = (html = '') =>
  html?.replace(/<[^>]*>/g, '')

  const formatCertifications = (certifications = "") => {
    return stripHtmlTags(certifications).replace(/&amp;/g, "&");
  };

  const isMobile = window.innerWidth <= 768;
  return (
    <>
      <div className="container  minht  ">
        {/* {advisorError && <p>Error fetching advisor data: {advisorError}</p>}
        {clientError && <p>Error fetching client data: {clientError}</p>} */}
        <div className="row">
          <div className="col-lg-6 col-5 col-md-12 ">
            {isLoading ? (
              <Skeleton
                circle
                style={{
                  width: isMobile ? "140px" : "500px",
                  height: isMobile ? "140px" : "500px",
                }}
              />
            ) : (
              <img
                src={advisorData?.image || "/assets/images/blank-profile.png"}
                alt="Advisor"
                className=" rounded-image home-avtar"
              />
            )}
          </div>
          <div className="col-7 d-block d-md-none">
            <h6 className="fw-medium">
              {" "}
              {isLoading ? (
                <Skeleton width={150} />
              ) : (
                `Hi, ${clientData?.salutation} ${fullName}`
              )}
            </h6>
            <h5 className="fw-normal">
              {isLoading ? (
                <Skeleton width={200} />
              ) : (
                <>
                  My name is {advisorData?.advisorName},{" "}
                  {advisorData?.designation} at FinEdge
                </>
              )}
              {/* ,{advisorData?.designation}{" "}  at FinEdge */}
            </h5>
            <p className=" fs-16 fw-normal d-none d-sm-block d-md-none">
              {isLoading ? (
                <Skeleton width={100} />
              ) : (
                <>
                  {" "}
                  <img
                    src="/assets/images/Suitcase.svg"
                    alt=""
                    className="darkmodechnge"
                  />
                  &nbsp;at FinEdge since:{" "}
                  <span className="fs-16">
                    {moment(advisorData?.dateOfJoining).format("MMMM YYYY")}
                  </span>
                </>
              )}

              {isLoading ? (
                <Skeleton width={100} />
              ) : (
                <>
                  <br />{" "}
                  <img
                    src="/assets/images/Check.svg"
                    alt=""
                    className="darkmodechnge"
                  />
                  &nbsp;Certifications:{" "}
                  <span className="fs-16">{formatCertifications(advisorData?.certifications)}</span>
                </>
              )}
            </p>
          </div>
          <div className="d-block d-sm-none mt-2">
            {/* Row 1: Date of Joining */}
            <div className="d-flex align-items-start mb-0">
              <img
                src="/assets/images/Suitcase.svg"
                alt=""
                className="darkmodechnge me-2"
                style={{ marginTop: 2 }}
              />
              <div className="fs-15">
                <span className="txt-color">At FinEdge since:</span>{" "}
                <span className="fs-16 txt-color">
                  {moment(advisorData?.dateOfJoining).format("MMMM YYYY")}
                </span>
              </div>
            </div>

            {/* Row 2: Certifications */}
            <div className="d-flex align-items-start">
              <img
                src="/assets/images/Check.svg"
                alt=""
                className="darkmodechnge me-2"
                style={{ marginTop: 2 }}
              />
              <div className="fs-15" style={{ lineHeight: "1.1" }}>
                <span className="txt-color">Certifications:</span>{" "}
                <span className="fs-16 txt-color">
                  {formatCertifications(advisorData?.certifications)}
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="row">
              <div className="col-12 d-none d-md-block ">
                <h6 className="fw-medium">
                  {" "}
                  {isLoading ? (
                    <Skeleton width={200} />
                  ) : (
                    `Hi, ${clientData?.salutation} ${fullName}`
                  )}
                </h6>
                <h5 className="fw-normal">
                  {isLoading ? (
                    <Skeleton width={300} />
                  ) : (
                    <>
                      My name is {advisorData?.advisorName},{" "}
                      {advisorData?.designation} at FinEdge
                    </>
                  )}
                  {/*,{" "} {advisorData?.designation} at FinEdge */}
                </h5>

                <p className="fw-normal d-flex justify-content-between gap-1 mb-1">
                  {isLoading ? (
                    <>
                      <Skeleton width={300} />
                      <Skeleton width={300} />
                    </>
                  ) : (
                    <>
                      <span className="d-flex justify-content-start gap-2  mb-lg-3 w-100">
                        <img
                          src="/assets/images/Check.svg"
                          alt=""
                          className="darkmodechnge"
                          style={{height:'25px'}}

                        />
                        <span>
                          Certifications:{" "}
                          <span className="fs-16 ">
                            {formatCertifications(advisorData?.certifications)}
                          </span>
                         
                        </span>
                      </span>
                      <span className="d-flex justify-content-start gap-2 mb-lg-3 w-100">
                        <img
                          src="/assets/images/Suitcase.svg"
                          alt=""
                          className="darkmodechnge"
                          style={{height:'25px'}}
                        />
                        <span>
                          at FinEdge since:{" "}
                          <span className="fs-16">
                            {moment(advisorData?.dateOfJoining).format(
                              "MMMM YYYY",
                            )}
                          </span>
                        </span>
                      </span>{" "}
                    </>
                  )}
                </p>
              </div>

              <div className="col-12 ">
                <p className="m-0 d-inline">
                  {isLoading ? (
                    <>
                      <Skeleton count={2} />
                    </>
                  ) : (
                    <>
                      I manage over{" "}
                      <span className=" fs-16">
                        {formatAUM(advisorData?.totalAdvisorAUM)}
                      </span>{" "}
                      of goal-based investments for my clients.{" "}
                    </>
                  )}
                </p>
                {isLoading ? (
                  <Skeleton count={1} height={100} />
                ) : (
                  <>
                    <span
                      className="txt-color"
                      dangerouslySetInnerHTML={{
                        __html: advisorData?.description,
                      }}
                    />
                  </>
                )}
              </div>
              {!isLoading && (
                <>
                  <div className="col-1 ">
                    <img
                      src="/assets/images/heart.png"
                      className="heart-icon"
                      alt=""
                    />
                  </div>

                  <div className="col-11 ">
                    <p className="px-2">
                      What I like most at work is that FinEdge encourages us to
                      keep client interest foremost at all times.
                    </p>
                  </div>
                </>
              )}
              <div className="col-12">
                {!isLoading && (
                  <>
                    <p>
                      This allows us to be advisors and not salespeople. We feel
                      proud when we add value to our client's financial lives
                      and help them achieve their financial goals. I sincerely
                      hope this Financial Plan will be the beginning of an
                      incredible journey with us, as your trusted advisor!
                    </p>
                  </>
                )}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 ">
                  {/* Contact Info */}
                  {isLoading ? (
                    <>
                      <Skeleton width={200} count={2} />
                      <Skeleton width={200} count={2} />
                    </>
                  ) : (
                    <>
                      <div>
                        <p className="fs-16 d-flex  align-items-start align-items-sm-center gap-2 ">
                          <span className="d-flex align-items-center gap-2">
                            <img
                              src="/assets/images/phone.svg"
                              alt="Phone"
                              className="darkmodechnge"
                              style={{ width: "20px", height: "20px" }}
                            />
                            {advisorData?.contactNumber}
                          </span>
                          <span className="d-flex align-items-center gap-2 ms-sm-3">
                            <img
                              src="/assets/images/mail.svg"
                              alt="Email"
                              className="darkmodechnge"
                              style={{ width: "20px", height: "20px" }}
                            />
                            {advisorData?.emailAddress}
                          </span>
                        </p>

                        <p className="fs-16 d-flex align-items-center gap-2">
                          <span className="darkmodechnge">
                            <GiRotaryPhone size={25} />
                          </span>
                          <a
                            href="tel:+91 124 6619500"
                            className="text-decoration-none txt-color"
                          >
                            <span className="text ">+91 124 6619500</span>
                          </a>
                        </p>
                      </div>

                      {/* LinkedIn Info */}
                      <div className="clrgreen d-flex flex-row flex-md-column align-items-md-end align-items-start mb-4  ">
                        <a
                          href={completeLinkedinUrl}
                          target="_blank"
                          className="text-decoration-none "
                          // style="text-decoration: none; background-color: #0A66C2; color: white; padding: 4px 6px; border-radius: 4px; margin-left: 8px; display: inline-flex; align-items: center;"
                          title="Advisor LinkedIn"
                        >
                          <span className="txt-color">
                            {" "}
                            {advisorData?.advisorName?.split(" ")[0]}'s{" "}
                          </span>
                          <span className=" darkmodechnge linkdin-color">
                            <IoLogoLinkedin size={30} />
                          </span>
                        </a>
                        <p className="d-flex align-items-center  ">
                          <a
                            href="https://www.linkedin.com/company/finedge-official/?viewAsMember=true"
                            target="_blank"
                            className="text-decoration-none "
                            // style="text-decoration: none; background-color: #0A66C2; color: white; padding: 4px 6px; border-radius: 4px; margin-left: 8px; display: inline-flex; align-items: center;"
                            title="Finedge LinkedIn"
                          >
                            <span className="txt-color"> FinEdge's </span>
                            <span className="darkmodechnge linkdin-color">
                              <IoLogoLinkedin size={30} />
                            </span>
                          </a>
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-4">
          <div className="row ">
            <div className="col text-end darkmodeclr">
              <a
                href="javascript:void(0);"
                className="ms-1"
                onClick={handleNext}
              >
                <img
                  className="arrow_next"
                  src="/assets/images/right-arrow.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
